export enum RentPaymentType {
	BankTransfer = 0,
	CardPayment = 10,
	Cash = 20
}